/**
 * parse the content of a dom element as json
 *
 * @param {string} domSelector
 * @returns {object}
 */
export default (domSelector) => {
  const domElement = document.querySelector(domSelector);

  if (!domElement) {
    return {};
  }

  return JSON.parse(domElement.textContent);
};
